<script setup lang="ts">
import { useModal } from "shared/composables";

const props = defineProps({
	title: {
		type: String,
		default: "Title",
		required: true
	},
	opened: {
		type: Boolean,
		default: true
	}
});

const { isModalOpened, toggleModal } = useModal();
isModalOpened.value = props.opened;
</script>

<template>
	<div :class="isModalOpened && 'drop-shadow-border'">
		<div
			class="flex items-center justify-between select-none p-5 border border-gray hover:cursor-pointer"
			@click="toggleModal"
		>
			<span class="font-medium text-lg">
				{{ title }}
			</span>
			<Icon v-if="isModalOpened" name="ic:round-minus" />
			<Icon v-else name="ic:round-plus" />
		</div>
		<div v-show="isModalOpened" class="p-5 pb-6 border border-t-0 border-gray">
			<span class="text-sm">
				<slot name="description"></slot>
			</span>
			<div>
				<slot name="image"></slot>
			</div>
		</div>
	</div>
</template>
